import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import { isProd } from 'src/config-global';
// Import only necessary routes for PointPay
import { pointPayAuthRoutes } from 'src/online-payment/auth/routes';

import { systemRoutes } from './system';
import { publicRoutes } from './public';
import { pointPayRoutes } from './pointpay';

// Shared site information and 404 pages
const Page404 = lazy(() => import('src/pages/404'));
const InfoPage = lazy(() => import('src/pages/info'));

// Import Payment Link page for non-prod testing
const PaymentLinkPage = lazy(() => import('src/pointpay-public/pages/payment-link'));

// ----------------------------------------------------------------------

export default function RouterPointPay() {
  const routes = [
    {
      path: '/',
      element: <Navigate to="/online-payment" replace />,
    },
    // Auth routes
    ...pointPayAuthRoutes,
    // PointPay specific routes
    ...pointPayRoutes,
    // System, public routes
    ...systemRoutes,
    ...publicRoutes,
    // Payment link route (non-prod only for testing)
    ...(!isProd
      ? [
          {
            path: '/payment-link/:id',
            element: <PaymentLinkPage />,
          },
        ]
      : []),
    // Site information and direct 404 route
    { path: '/info', element: <InfoPage /> },
    { path: '/404', element: <Page404 /> },
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  return useRoutes(routes);
}
